class PartalarmOrderField extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('textarea');
    if (!this.input) return;
    this.syncName = () => {
      if (this.input.value.trim()) {
        this.input.name = this.input.dataset.propertyName;
      } else {
        this.input.removeAttribute('name');
      }
    };
    this.input.addEventListener('input', this.syncName);
    this.input.addEventListener('change', this.syncName);
    this.form = this.input.form;
    this.cleanFormData = (event) => {
      if (!this.input.value.trim()) event.formData.delete(this.input.dataset.propertyName);
    };
    this.form?.addEventListener('formdata', this.cleanFormData);
    this.syncName();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.syncName);
    this.input?.removeEventListener('change', this.syncName);
    this.form?.removeEventListener('formdata', this.cleanFormData);
  }
}

if (!customElements.get('partalarm-order-field')) {
  customElements.define('partalarm-order-field', PartalarmOrderField);
}
